<!--
 - Author : wanghongling.
 - Date   : 2019/7/25.
 - File   : excepHandle.异常信息详情,处置异常，异常处置详情弹窗
 -->

<template>
  <Popover title="异常信息" width="560px" @closeEvent="closePop" class="excep-handle">
    <div :class="[isScroll?'isScroll':'']">
      <div class="ex-detail">
        <!--异常信息详情-->
        <div v-if="current.exceptionImageUrl" class="detail-img" @click="showPic(current.exceptionImageUrl)">
          <img :src="current.exceptionImageUrl">
        </div>
        <div class="ex-detail-r" :style="{width: current.exceptionImageUrl?'38%':'100%'}">
          <span class="detail-tit">设备名称 </span><span class="detail-ct">{{current.deviceName||'无'}}</span>
          <div class="detail-inline">
            <p class="detail-tit">所属点位： </p>
            <p class="detail-ct">{{current.anchorName||'无'}}</p>
          </div>
          <div class="detail-inline">
            <p class="detail-tit">所属食堂：</p>
            <p class="detail-ct">{{current.deptName||'无'}}</p>
          </div>
          <div class="detail-inline">
            <p class="detail-tit">所属区域：</p>
            <p class="detail-ct">{{current.regionName||'无'}}</p>
          </div>
          <div class="detail-inline">
            <p class="detail-tit">异常类型：</p>
            <p class="detail-ct">{{current.anomalousTypeName||'无'}}</p>
          </div>
          <div class="detail-inline">
            <p class="detail-tit">异常时间：</p>
            <p class="detail-ct">{{current.occurrenceTime||'无'}}</p>
          </div>
          <p class="detail-tit">告警内容：</p>
          <p class="detail-ct">{{current.content||'无'}}</p>
        </div>
      </div>
      <div v-if="showChuRegion">
        <!--异常处置操作-->
        <p class="yc-title">处置信息：</p>
        <div v-if="current.status === '01'" style="margin-top: 10px;">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item label="" prop="desc">
              <el-input type="textarea" v-model="ruleForm.desc" maxlength=300 :autosize="{ minRows: 3, maxRows: 4}"
                  placeholder="请输入处置情况">
              </el-input>
            </el-form-item>
          </el-form>
          <el-upload
              style="padding: 0 0 15px 0"
              action="#"
              ref="upload"
              list-type="picture-card"
              :disabled = "loading"
              :on-remove="handleRemove"
              :before-upload="beforeUpload"
              :limit="8"
              :on-exceed="handleExceed"
              multiple
              accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
              :http-request="handleHttpRequest">
            <i class="el-icon-plus"  v-loading="loading"
                element-loading-text=""
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"></i>
          </el-upload>
          <div class="footer-btn">
            <el-button @click="cancelFn">取消</el-button>
            <el-button type="primary" @click="updateExceptionInfo" :disabled="disabled" :v-loading="disabled"
                element-loading-text="提交中"
                element-loading-spinner="el-icon-loading">确定</el-button>
          </div>
        </div>
        <!--异常处置详情-->
        <div v-else>
          <p class="yc-detail">{{yCCLDetail.explanation || '暂无'}}</p>
          <div class="img-list">
            <div class="img-list-item" v-for="item in yCCLDetail.fileList" :key="item"
                @click="showPic(imgUrl+item)">
              <div>
                <img :src="item?imgUrl+item:''" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Popover>
</template>

<script>
  import {upload} from '@/utils/fileServer'
  export default {
    name: 'excepHandle',
    data () {
      return {
        imgUrl: this.$store.getters.fileApi,
        cameraImgUrl: window.localStorage.getItem('cameraImgUrl'),
        ruleForm: {
          desc: '' // 填写处置详情
        },
        rules: {
          desc: [
            { required: true, message: '请输入处置情况', trigger: 'blur' }
          ]
        },
        dialogVisible: false,
        uploadList: [],
        loading: false
      }
    },
    props: {
      isScroll: false, //是否显示滚动条
      reset: {},
      yCCLDetail: {}, // 异常处理详情
      current: {},
      disabled: false, // 处置按钮是否可以操作
      showChuRegion: false // 处置异常信息弹窗
    },
    methods: {
      /**
       * 关闭异常详情信息弹窗
       * @author wanghongling
       * @createTime 2019/07/23
       */
      closePop() {
        this.$emit('closeEC')
      },
      /**
       * 删除图片
       * @author wanghongling
       * @param file
       * @param fileList
       * @createTime 2019/07/24
       */
      handleRemove (file, fileList) {
        console.error('handleRemove', file, fileList)
        console.log(file, fileList)
        var id = file.response ? file.response.fileId : file.id
        var index = this.uploadList.indexOf(id)
        this.uploadList.splice(index, 1)
      },
      /**
       * 在选择图片上传前，关闭弹窗
       * @author wanghongling
       * @param file
       * @createTime 2019/07/24
       * @param file 图片信息.jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP
       */
      beforeUpload (file) {
        const isJPG = ['image/jpeg', 'image/hepg', 'image/gif', 'image/png'].indexOf(file.type) > -1
        const isLt2M = file.size / 1024 / 1024 < 5
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 jpg，hepg，gif，png 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 5MB!')
        }
        return isJPG && isLt2M
      },
      /**
       * 限制上传图片个数弹窗
       * @author wanghongling
       * @param files
       * @param fileList
       * @createTime 2019/07/24
       * @files 图片信息
       */
      handleExceed() {
        this.$superMessage('提示', '最多上传8张图')
      },
      /**
       * 自定义上传行为
       * 1.用户获取图片转为base64作为预览 2.上传到文件服务器
       * @files 图片信息
       * @author wanghongling
       * @createTime 2019/07/24
       */
      handleHttpRequest (files) {
        this.loading = true
        this.dialogVisible = false
        let reader = new FileReader()
        reader.readAsDataURL(files.file)
        upload({fileName: files.file.name, file: files.file}).then(res => {
          this.dialogVisible = false
          this.uploadList.push(res.fileId)
          console.log('this.uploadList', this.uploadList)
          this.loading = false
        }).catch(e => {
          console.error(e)
          this.loading = false
        // this.$superMessage('提示', e)
        })
      },
      /**
       * 异常处置
       * @author wanghongling
       * @createTime 2019/07/23
       */
      updateExceptionInfo () {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.$emit('chuZhiFn', this.ruleForm.desc, this.uploadList)
          }
        })
      },
      /**
       * 显示查看图片框
       * @author: whl
       * @createDate: 2019/6/21
       * @param item 图片信息
       * @return {Object}
       */
      showPic (item) {
        this.$superMessage('查看图片', '', {imgPic: item, btnShow: false}).then().catch()
      },
      /**
       * 取消操作
       * @author wanghongling
       * @createDate 2019/07/26
       */
      cancelFn() {
        this.$emit('cancelFn')
      }
    },
    watch: {
      /**
       * 切换的时候处置框填写的信息重置
       * @author wanghongling
       * @createDate 2019/07/26
       */
      reset () {
        if(this.current.status === '01') {
          this.ruleForm.desc = ''
          this.uploadList = []
          // this.$refs.upload.clearFiles()
        }
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">

  @import '../../assets/less/color';
  .excep-handle{
    .detail-img {
      display: inline-block;
      width: 60%;
      vertical-align: top;
      cursor: pointer;

      img {
        width: 95%;
      }
    }
    .isScroll{
      max-height: 420px;
      overflow: auto;
    }
    .ex-detail{
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px #009cff dashed;
    }
    .ex-detail-r {
      display: inline-block;
      width: 38%;
      font-size: 14px;
      .detail-inline{
        display: flex;
        align-items: center;
      }
      .detail-tit {
        color: @darkBlue;
        line-height: 30px;
      }

      .detail-ct {
        color: @lightBlue;
      }
    }
    .el-upload--picture-card {
      background-color: #022643 !important;
      border: 2px dashed #044c7f !important;
      width: 75px;
      height: 75px;
      line-height: 78px;
    }
    .el-upload-list--picture-card .el-upload-list__item{
      width: 75px;
      height: 75px;
    }
    .el-upload--picture-card i {
      color: #0475b7;
      font-weight: bolder;
    }
    .yc-title{
      font-size: 16px;
      color: #fff;
    }
    .yc-detail{
      color: #00b7ee;
      padding: 5px 0;
    }
    .img-list{
      display: flex;
      margin: 10px 0;
      flex-wrap: wrap;
      &-item{
        margin-right: 2%;
        cursor: pointer;
        div{
          width: 95px;
          height: 95px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            object-fit: none;
            max-width: 100%;
          }
        }
      }
    }
    .footer-btn{
      text-align: center;
      .el-button{
        padding: 10px 40px !important;
        background-color: #35556d;
        border-color: #35556d;
        color: #fff;
      }
      .el-button--primary {
        font-size: 16px !important;
        background-color: #009cff;
        border-color: #009cff;
      }
      .el-button--primary:hover{
        background-color: #e68d00 !important;
        border-color: #e68d00 !important;
      }
      .el-button:hover{
        background-color: #045591;
        border-color: #045591;
      }
    }
    .el-input__inner, .el-textarea__inner{
      background-color: #022643 !important;
      border: 1px solid #0a5c9c !important;
    }
    .el-form-item__label{
      color: #fff !important;
    }
    .el-input__inner, .el-textarea__inner{
      color: #00ffff !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/excepHandle.vue